// extracted by mini-css-extract-plugin
module.exports = {"toolbarIcon":"ToolBarIcon_toolbarIcon__p3btv","dark":"ToolBarIcon_dark__YuDa7","required":"ToolBarIcon_required__1W9XQ"};